import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string-for-all';
import HeartIcon from 'mdi-react/HeartIcon';

import { brandColors, layout, media } from '@prisjakt/ui-base';

import { H2Text } from '@prisjakt/ui/text/variants';
import Button from '@prisjakt/ui-button';
import ModalComponent from '../../../../components/modal';

const LOGO_HEIGHT = 40;

const Modal = styled(ModalComponent)`
  && {
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
  }
`;

const Title = styled(H2Text)`
  && {
    font-size: 24px;
  }
`;

const Content = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${layout.measurements.spacingMedium};

  > *:not(:last-child) {
    margin-bottom: ${layout.measurements.spacingNormal};
  }
`;

const Brands = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${media.smallOnly`
    flex-direction: column;
  `};
`;

const PJLogo = styled.img`
  height: ${LOGO_HEIGHT}px;
`;

const AdvizedLogo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .parrot {
    height: ${LOGO_HEIGHT}px;
    margin-right: 5px;
  }

  .text {
    width: 110px;
    height: 100%;
  }
`;

const Icon = styled(HeartIcon)`
  margin-left: ${layout.measurements.spacingNormal};
  margin-right: ${layout.measurements.spacingNormal};

  ${media.smallOnly`
    margin-bottom: ${layout.measurements.spacingNormal};
    margin-top: ${layout.measurements.spacingNormal};
  `};
`;

function ExpertRedirectMessage() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { push } = useHistory();

  const { notification, ...queryParams } = qs.parse(location.search);

  useEffect(() => {
    try {
      const shouldOpen = !localStorage.getItem(
        'pj:advizedRedirectMessageShown'
      );

      if (shouldOpen) {
        setOpen(true);
      }
    } catch (err) {} // eslint-disable-line
  }, []);

  const handleClose = () => {
    setOpen(false);
    push(`${location.pathname}?${qs.stringify(queryParams)}`);

    try {
      localStorage.setItem('pj:advizedRedirectMessageShown', 'true');
    } catch (err) {} // eslint-disable-line
  };

  return (
    <Modal isOpen={open} width={600} onRequestClose={handleClose}>
      <Content>
        <Title>Advized är nu en del av Prisjaktfamiljen</Title>
        <Brands>
          <PJLogo
            alt=""
            src="https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_se_v2_dark.svg"
          />

          <Icon color={brandColors.expert} size={40} />

          <AdvizedLogo>
            <img
              alt=""
              className="parrot"
              src="https://pricespy-75b8.kxcdn.com/g/rfe/logos/advized/advized-parrot.png"
            />
            <img
              alt=""
              className="text"
              src="https://pricespy-75b8.kxcdn.com/g/rfe/logos/advized/advized-text.png"
            />
          </AdvizedLogo>
        </Brands>
        <div style={{ width: '75%' }}>
          Advizeds experter har flyttat in på Prisjakt. Här fortsätter de skapa
          personliga topplistor och tester som du kan lita på.
        </div>
        <Button size="large" color="primary" onClick={handleClose}>
          Låt Prisjakt Experter hjälpa dig
        </Button>
      </Content>
    </Modal>
  );
}

export default ExpertRedirectMessage;
